class EditPolyline{

}

export default EditPolyline